export default __webpack_public_path__ + "static/media/wipe-data.e0269ac2.png";